/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  FirewallPolicy,
  FirewallPolicy$Outbound,
  FirewallPolicy$outboundSchema,
} from "./firewallpolicy.js";
import {
  LoggingPolicy,
  LoggingPolicy$Outbound,
  LoggingPolicy$outboundSchema,
} from "./loggingpolicy.js";
import {
  MatchExpr,
  MatchExpr$Outbound,
  MatchExpr$outboundSchema,
} from "./matchexpr.js";

/**
 * A gateway policy. Exactly one of `firewall`,
 *
 * @remarks
 * or `logging` must be set. The server generates an id for every
 * policy it stores.
 */
export type Policy = {
  /**
   * Human-readable name shown in the dashboard.
   */
  name: string;
  /**
   * Disabled policies are stored but skipped during evaluation.
   */
  enabled: boolean;
  /**
   * Optional request matchers. The policy applies only to requests matching
   *
   * @remarks
   * all expressions; omit to apply to every request.
   */
  match?: Array<MatchExpr> | undefined;
  /**
   * Blocks matching requests.
   */
  firewall?: FirewallPolicy | undefined;
  /**
   * Adds request data to the log entries of matching requests. The gateway
   *
   * @remarks
   * always records a basic log entry for every request: method, host, path,
   * status, and latency. Each capture setting is a separate opt-in: request
   * headers, response headers, request body, response body, and query data.
   * The policy's `match` expressions select the requests. A policy without
   * `match` expressions matches every request. If more than one enabled
   * logging policy matches a request, the gateway combines their settings.
   * The gateway always redacts the `Authorization` header and configured key
   * locations before it stores headers or query data.
   */
  logging?: LoggingPolicy | undefined;
};

/** @internal */
export type Policy$Outbound = {
  name: string;
  enabled: boolean;
  match?: Array<MatchExpr$Outbound> | undefined;
  firewall?: FirewallPolicy$Outbound | undefined;
  logging?: LoggingPolicy$Outbound | undefined;
};

/** @internal */
export const Policy$outboundSchema: z.ZodType<
  Policy$Outbound,
  z.ZodTypeDef,
  Policy
> = z.object({
  name: z.string(),
  enabled: z.boolean(),
  match: z.array(MatchExpr$outboundSchema).optional(),
  firewall: FirewallPolicy$outboundSchema.optional(),
  logging: LoggingPolicy$outboundSchema.optional(),
});

export function policyToJSON(policy: Policy): string {
  return JSON.stringify(Policy$outboundSchema.parse(policy));
}
